export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';
export const RESET_FORGET_PASSWORD = 'RESET_FORGET_PASSWORD';
export const FORGOT_PASSWORD_CHANGE = 'FORGOT_PASSWORD_CHANGE';
